// Mock inventory data for Dealer Insights dashboard
export const mockInventoryData = [
  {
    id: "cd35acdc-9ef5-4cd6-86eb-388fdbbc2a42",
    vin: "WBA5B3C55ED536061",
    year: 2014,
    make: "BMW",
    model: "5 Series",
    trim: "535i",
    price: 12500.0,
    mileage: 80025,
    dom: 87,
    image_url: "https://mc-api.marketcheck.com/v2/image/cache/car/WBA5B3C55ED536061-a3c91a61-5f67/6799cbe1bb34d6c2522ed4701af50432?api_key=VWCF31zpgU9xscCGo8oBe9JzJ2RcKhhA",
    version: "535i xDrive Sedan",
    market_avg_price: 13988.0,
    market_avg_delta: 10.64,
    price_status: "green",
    market_listing_count: 8,
    market_sold_count: 14,
    sold_dom: 100,
    listing_rank: 1,
    overall_rank: 4,
    listing_comparables: 3,
    active_count_delta: 0,
    sold_count_delta: -1,
    listing_rank_delta: 0,
    active_listings: [
      {
        vin: "WBA5B3C55ED536061",
        heading: "2014 BMW 5SERIES",
        price: 12500,
        miles: 80025,
        vdp_url: "https://autovaultdistro.com/inventory/BMW/5SERIES/0021",
        dom_active: 87,
        photo: "https://imagescf.dealercenter.net/1116/836/202510-7ebc61bd421f451b8b7c36f786616de9.jpg",
        dealer_name: "Auto Vault Distributors Llc",
        dealer_type: "independent",
        first_seen_at_date: "2025-11-11T16:23:56.000Z",
        version: "535i xDrive Sedan",
        body_type: "Sedan",
        drivetrain: "4WD",
        transmission: null,
        exterior_color: null,
        interior_color: null
      }
    ],
    sold_listings: [
      {
        vin: "WBA5B3C54ED537119",
        heading: "2014-BMW-5-Series-535i-xDrive",
        price: 16850,
        miles: 45780,
        vdp_url: "http://www.apexcars.net/pre-owned-cars/detail/2014-BMW-5-Series-535i-xDrive/1384648",
        dom: 35,
        dom_active: 33,
        photo: "https://mc-api.marketcheck.com/v2/image/cache/car/WBA5B3C54ED537119-469cf071-72b5/9a41096006f2c3e4cd4e69d0404f78fb?api_key=VWCF31zpgU9xscCGo8oBe9JzJ2RcKhhA",
        dealer_name: "Apexcars.net",
        dealer_type: "independent",
        last_seen_at_date: "2025-11-09T13:54:19.000Z",
        version: "535i xDrive Sedan",
        body_type: "Sedan",
        drivetrain: "4WD",
        transmission: "Automatic",
        exterior_color: "Blue",
        interior_color: "Black"
      }
    ]
  },
  {
    id: "71288149-1c8e-46a1-827d-aa20658a2099",
    vin: "JTDKDTB37H1596445",
    year: 2017,
    make: "Toyota",
    model: "Prius c",
    trim: "One",
    price: 13000.0,
    mileage: 113100,
    dom: 49,
    image_url: null,
    version: "One",
    market_avg_price: 13498.0,
    market_avg_delta: 3.69,
    price_status: "green",
    market_listing_count: 3,
    market_sold_count: 1,
    sold_dom: 148,
    listing_rank: 1,
    overall_rank: 2,
    listing_comparables: 2,
    active_count_delta: 0,
    sold_count_delta: 0,
    listing_rank_delta: 0,
    active_listings: [
      {
        vin: "JTDKDTB37H1596445",
        heading: "2017 TOYOTA PRIUSC",
        price: 13000,
        miles: 113100,
        vdp_url: "https://autovaultdistro.com/inventory/TOYOTA/PRIUSC/0030",
        dom_active: 49,
        photo: "https://imagescf.dealercenter.net/1116/836/202512-88b69311a2654b43a76b77bbf6c39e8e.jpg",
        dealer_name: "Auto Vault Distributors Llc",
        dealer_type: "independent",
        first_seen_at_date: "2025-12-07T15:39:30.000Z",
        version: "One",
        body_type: "Hatchback",
        drivetrain: "FWD",
        transmission: null,
        exterior_color: "Orange",
        interior_color: "Gray"
      }
    ],
    sold_listings: [
      {
        vin: "JTDKDTB37H1598485",
        heading: "2017 Toyota Prius c One",
        price: 11998,
        miles: 92226,
        vdp_url: "https://www.approvedautoz.com/details/used-2017-toyota-prius-c/114682918",
        dom: 199,
        dom_active: 148,
        photo: "https://mc-api.marketcheck.com/v2/image/cache/car/JTDKDTB37H1598485-5bd7c5ae-27d5/6e0d40e17bc6222d4a0e172941b08051?api_key=VWCF31zpgU9xscCGo8oBe9JzJ2RcKhhA",
        dealer_name: "Approved Autos",
        dealer_type: "independent",
        last_seen_at_date: "2025-11-22T10:21:53.000Z",
        version: "One",
        body_type: "Hatchback",
        drivetrain: "FWD",
        transmission: "CVT",
        exterior_color: "Blue",
        interior_color: "Gray"
      }
    ]
  },
  {
    id: "ce42ab5a-929c-40f7-9908-de71c4e83d5b",
    vin: "5J6RE385X9L030008",
    year: 2009,
    make: "Honda",
    model: "CR-V",
    trim: "EX",
    price: 9000.0,
    mileage: 134600,
    dom: 75,
    image_url: "https://mc-api.marketcheck.com/v2/image/cache/car/5J6RE385X9L030008-81d82719-c2b8/9759f3b17c9217723df15992b8c5ee1a?api_key=VWCF31zpgU9xscCGo8oBe9JzJ2RcKhhA",
    version: "EX",
    market_avg_price: 7850.0,
    market_avg_delta: -14.65,
    price_status: "red",
    market_listing_count: 5,
    market_sold_count: 4,
    sold_dom: 22,
    listing_rank: 3,
    overall_rank: 5,
    listing_comparables: 3,
    active_count_delta: 0,
    sold_count_delta: 0,
    listing_rank_delta: 0,
    active_listings: [
      {
        vin: "5J6RE385X9L030008",
        heading: "2009 HONDA CR-V",
        price: 9000,
        miles: 134600,
        vdp_url: "https://autovaultdistro.com/inventory/HONDA/CR-V/0026",
        dom_active: 75,
        photo: "https://imagescf.dealercenter.net/1116/836/202511-706e41cce561423fa445ec5fc5609593.jpg",
        dealer_name: "Auto Vault Distributors Llc",
        dealer_type: "independent",
        first_seen_at_date: "2025-11-11T16:25:15.000Z",
        version: "EX",
        body_type: "SUV",
        drivetrain: "FWD",
        transmission: null,
        exterior_color: "Red",
        interior_color: "Gray"
      }
    ],
    sold_listings: [
      {
        vin: "5J6RE38549L020929",
        heading: "Used  2009 Honda CR-V EX",
        price: 8998,
        miles: 123164,
        vdp_url: "https://www.stevenscreekmazda.com/inventory/used-2009-honda-cr-v-ex-fwd-sport-utility-5j6re38549l020929/",
        dom: 18,
        dom_active: 18,
        photo: "https://mc-api.marketcheck.com/v2/image/cache/car/5J6RE38549L020929-1cc59c4e-3e1d/89d18ce95fbe3b2f6b80c8df614f6de8?api_key=VWCF31zpgU9xscCGo8oBe9JzJ2RcKhhA",
        dealer_name: "Stevens Creek Mazda",
        dealer_type: "franchise",
        last_seen_at_date: "2025-12-14T10:16:32.000Z",
        version: "EX",
        body_type: "SUV",
        drivetrain: "FWD",
        transmission: "Automatic",
        exterior_color: "Gray",
        interior_color: "White"
      }
    ]
  },
  {
    id: "f8f6d9a6-b3f3-4eea-8832-adc6ae6d8975",
    vin: "5FNYF6H32GB102253",
    year: 2016,
    make: "Honda",
    model: "Pilot",
    trim: "EX",
    price: 19000.0,
    mileage: 57500,
    dom: 54,
    image_url: "https://mc-api.marketcheck.com/v2/image/cache/car/5FNYF6H32GB102253-60b0310a-f1dd/950d994f2df953811629fc8893db2a63?api_key=VWCF31zpgU9xscCGo8oBe9JzJ2RcKhhA",
    version: "4WD EX",
    market_avg_price: 19000.0,
    market_avg_delta: 0.0,
    price_status: "red",
    market_listing_count: 6,
    market_sold_count: 6,
    sold_dom: 36,
    listing_rank: 1,
    overall_rank: 6,
    listing_comparables: 1,
    active_count_delta: 0,
    sold_count_delta: 0,
    listing_rank_delta: 0,
    active_listings: [
      {
        vin: "5FNYF6H32GB102253",
        heading: "2016 HONDA PILOT",
        price: 19000,
        miles: 57500,
        vdp_url: "https://autovaultdistro.com/inventory/HONDA/PILOT/0031",
        dom_active: 54,
        photo: "https://imagescf.dealercenter.net/1116/836/202512-531250fdb09948bf9219ca6b5103cf06.jpg",
        dealer_name: "Auto Vault Distributors Llc",
        dealer_type: "independent",
        first_seen_at_date: "2026-01-08T00:35:49.000Z",
        version: "4WD EX",
        body_type: "SUV",
        drivetrain: "4WD",
        transmission: null,
        exterior_color: "Blue",
        interior_color: "Beige"
      }
    ],
    sold_listings: [
      {
        vin: "5FNYF6H38GB021712",
        heading: "2016 Honda Pilot EX",
        price: 13798,
        miles: 123432,
        vdp_url: "https://www.dublintoyota.com/used-Dublin-2016-Honda-Pilot-EX-5FNYF6H38GB021712",
        dom: 111,
        dom_active: 26,
        photo: "https://mc-api.marketcheck.com/v2/image/cache/car/5FNYF6H38GB021712-667e1455-2511/74b1cf6fff7460750d25bb862954f370?api_key=VWCF31zpgU9xscCGo8oBe9JzJ2RcKhhA",
        dealer_name: "Dublin Toyota",
        dealer_type: "franchise",
        last_seen_at_date: "2025-11-23T09:40:20.000Z",
        version: "4WD EX",
        body_type: "SUV",
        drivetrain: "4WD",
        transmission: "Automatic",
        exterior_color: null,
        interior_color: null
      }
    ]
  }
];
